export default "__VITE_ASSET__CAk5hSVR__"